import { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase/firebase";

function ReadOnlyRecords({ founderId }) {
  const [records, setRecords] = useState([]);

  useEffect(() => {
    const load = async () => {
      const q = query(
        collection(db, "startupRecords"),
        where("userId", "==", founderId)
      );
      const snap = await getDocs(q);
      setRecords(snap.docs.map((d) => d.data()));
    };
    load();
  }, [founderId]);

  return (
    <div className="card" style={{ padding: 24, marginBottom: 24 }}>
      <h3>Startup Records</h3>

      {records.length === 0 ? (
        <p>No records shared.</p>
      ) : (
        records.map((r, i) => (
          <div key={i} style={{ marginTop: 12 }}>
            <strong>{r.title}</strong>
            <br />
            <a
              href={r.type === "link" ? r.linkUrl : r.fileUrl}
              target="_blank"
              rel="noreferrer"
            >
              View
            </a>
          </div>
        ))
      )}
    </div>
  );
}

export default ReadOnlyRecords;
